import { makeStyles } from '@mui/styles';
import { palette } from '@livable/saas-react-components';
const useStyles = makeStyles({
  contentWrapper: {
    backgroundColor: palette.common.white,
    maxHeight: '420px',
    overflowY: 'auto',
    padding: '32px 40px 24px 40px',
    '& .MuiChip-root': {
      display: 'flex',
      marginBottom: '16px',
      alignItems: 'center',
      justifyContent: 'flex-start'
    }
  },
  contentRow: {
    display: 'flex',
    margin: '0 -5px',
    alignItems: 'center',
    justifyContent: 'center',
    '&:not(:last-child)': {
      marginBottom: '24px'
    }
  },
  contentItem: {
    width: '100%',
    padding: '0 5px',
    '&.input': {
      maxWidth: '120px'
    },
    '&.modal': {
      maxWidth: '174px',
      '& .MuiButton-root': {
        width: '100%',
        height: '48px',
        '& .MuiSvgIcon-root path': {
          fill: palette.info.main
        }
      }
    },
    '&.remove': {
      maxWidth: '58px',
      '& .MuiButton-root': {
        height: '48px',
        minWidth: '48px'
      }
    }
  },
  contentSetting: {
    height: '72px',
    backgroundColor: palette.common.white,
    padding: '8px 40px 0 40px',
    display: 'flex',
    alignItems: 'center',
    '& .MuiButton-root': {
      height: '48px',
      fontSize: '15px'
    },
    '& > div': {
      position: 'relative',
      '&:first-child': {
        '& .MuiButton-root': {
          borderTopRightRadius: '0',
          borderBottomRightRadius: '0'
        }
      },
      '&:last-child': {
        marginLeft: '1px',
        '& .MuiButton-root': {
          borderTopLeftRadius: '0',
          borderBottomLeftRadius: '0',
          '&.active svg': {
            transform: 'rotateZ(180deg)'
          }
        }
      }
    }
  },
  menuBlockControls: {
    borderRadius: '2px',
    backgroundColor: palette.common.white,
    boxShadow: '0px 18px 32px 0px rgba(0, 0, 0, 0.15)',
    position: 'absolute',
    bottom: 'calc(100% + 4px)',
    zIndex: '1',
    minWidth: '180px'
  },
  warningButton: {
    backgroundColor: "".concat(palette.warning.light),
    border: "1px solid ".concat(palette.warning.main),
    '&:hover': {
      backgroundColor: "".concat(palette.warning.light),
      border: "1px solid ".concat(palette.shades[700])
    }
  },
  copyToAll: {
    marginLeft: '-5px',
    position: 'relative',
    '& .MuiButton-root': {
      height: '48px',
      padding: '0 20px',
      borderLeft: 'none',
      borderTopLeftRadius: '0',
      borderBottomLeftRadius: '0'
    },
    '&.hidden:after': {
      top: '0',
      left: '0',
      right: '0',
      bottom: '0',
      content: '""',
      display: 'block',
      position: 'absolute',
      background: '#fff'
    }
  }
});
export default useStyles;